const usuarioLogado = (state) => {
    return state.login;
}

const logando = (state) => {
    return state.logando;
}

const listaDeAreasResponsaveis = (state) => {
    return state.itemsAreaResponsavel || [];
}

const listaDeTiposOS = (state) => {
    return state.itemsTipoOs || [];
}

const listaDeAtividades = (state) => {
    return state.itemsAtividade || [];
}

const listaDeGruposAtividades = (state) => {
    return state.itemsGrupoAtividade || [];
}

const loadingModos = (state) => {
    return state.buscando
}

const listaDeFormularios = (state) => {
    return state.formularios
}

const listaDeJanelas = (state) => {
    return state.janelas || [];
}

const listaDeOrdensDeServicos = (state) => {
    return state.itemsOrdemServico || [];
}

const listaTarefaAposIncluirOS = (state) => {
    return state.itemsTarefasDisponiveis || [];
}

export {
    usuarioLogado,
    logando,
    listaDeAreasResponsaveis,
    listaDeTiposOS,
    listaDeAtividades,
    listaDeGruposAtividades,
    loadingModos,
    listaDeFormularios,
    listaDeJanelas,
    listaDeOrdensDeServicos,
    listaTarefaAposIncluirOS
}